export default {
  label: {
    title: 'Importar arquivo',
    file: 'Arquivo',
    insertFile: 'Selecione o documento',
    cancel: 'Cancelar',
    ok: 'Ok',
    send: 'Enviar',
    clear: 'Limpar',
    requiredValue: 'Valor obrigatório',
    queued: 'Processando',
    proccessed: 'Processada com successo',
    status: 'Status: ',
    totalPosts: 'Total de Publicações: ',
    dataStorageUrl: 'Link da planilha processada: ',
    errorMessage: 'Descrição do erro: ',
  },

  infoLabel: 'Informações do formulário',
  closeLabel: 'Fechar informações',
  exportLinkText: 'Link da planilha processada',

  upload: {
    error: 'Há erros em posts na planilha, verifique os dados e tente novamente.',
    success: 'Documento carregado com sucesso',
  },

  faq: {
    title: 'Qual o formato da planilha?',
    description: 'A planilha deve estar no formato .xlsx e no formato correto para a importação.',
  },
  faq2: {
    title: 'Qual é a formatação correta da planilha?',
    description: 'Basta seguir a planilha base enviada na contratação do componente.',
  },
  faq3: {
    title: 'Como saber se meus dados foram importados?',
    description: 'Os dados importados aparecerão no Warroom, no mural de publicações dentro do canal "Dados Importados".',
  },
  faq4: {
    title: 'O que fazer caso a planilha apresente erro?',
    description: 'O componente retornará um link da planilha com todas as linhas que apresentaram erros, informando-os. É possível corrigir os erros da planilha retornada e reenviar para que seja importada corretamente.',
  },
};
